const tabList = [
  {
    name: 'Overview',
    path: '/Customers/:adfitNo/Overview',
  },
  {
    name: 'Payments',
    path: '/Customers/:adfitNo/Payments',
  },
  {
    name: 'Transactions',
    path: '/Customers/:adfitNo/Transactions',
  },
  {
    name: 'Payment Method',
    path: '/Customers/:adfitNo/PaymentMethod',
  },
  {
    name: 'Activities',
    path: '/Customers/:adfitNo/Activities',
  },
  {
    name: 'Variations',
    path: '/Customers/:adfitNo/Variations',
  },
  {
    name: 'Contract',
    path: '/Customers/:adfitNo/Contract',
  },
];

export default tabList;
